import { Badge, Skeleton } from "@shortsworks/ui";
import { CanvasSkeleton } from "@app/components/WidgetStudio/Canvas/skeletons/DesktopSkeleton/CanvasSkeleton";
import { Search, ShoppingCart } from "lucide-react";

export const DesktopSkeletonHeader = () => {
  return (
    <div className="flex items-center justify-between mt-5 mx-5">
      <div className="flex gap-4">
        <CanvasSkeleton className="h-8 w-36 rounded-xl" />
        <CanvasSkeleton className="h-8 w-72 rounded-2xl flex items-center justify-end px-2">
          <Search className="h-4 w-4 text-foreground" />
        </CanvasSkeleton>
      </div>
      <div className="flex gap-2">
        <CanvasSkeleton className="h-8 w-24 rounded-xl flex items-center justify-end px-2">
          {/*<ShoppingCart className=" h-4 w-4" />*/}
        </CanvasSkeleton>
        {/*<CanvasSkeleton className="h-8 w-24 rounded-lg" />*/}
      </div>
    </div>
  );
};
